import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';

@Injectable()
export class CommonService {
    constructor(private fiBackend: FiBackendService) {}

    GetPhones(objectId, objectType) {
        return this.fiBackend.fetchData<any[]>(`Core/Common/GetPhones/${objectId}/${objectType}`);
    }

    getGlobalDatabases() {
        return this.fiBackend.fetchData<string[]>(`Core/Common/GetGlobalDatabases`);
    }
}
